import {Ballot} from '../types/ballot'

export const backupBallot: Partial<Ballot> = {
  ballot_name: 'SceneThink Best of Ballot',
  general: {
    meta_info: {
      content: {
        title: 'SceneThink Best of Ballot',
        metadescription: 'Best of Ballot allows your audience to nominate, vote, and view the best your area has to offer.',
        metaogimage: 'https://ucarecdn.com/c8599098-7a59-48bd-9f16-06aee754f7f8/',
        metaogtitle: 'Best of Ballot powered by SceneThink',
        metaogdescription: 'Best of Ballot allows your audience to nominate, vote, and view the best your area has to offer.',
        metaogurl: 'https://scenethink.com/',
        metaogsite_name: 'SceneThink Best of Ballot',
        metatwittersite: '',
        metatwittercard: 'summary_large_image',
        metatwitterimagealt: 'Best of Ballot',
        fbapp_id: '',
      },
    },
    favicon: {url: ''},
  } as any,
}
